import { render, staticRenderFns } from "./PopupTextColumns.vue?vue&type=template&id=bbfc29f6&"
import script from "./PopupTextColumns.vue?vue&type=script&lang=js&"
export * from "./PopupTextColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports